<template>
  <BittsModal
    class="book-meeting-modal"
    variant="primary"
    :primary-button-text="isSubmitted ? 'Close' : 'Skip'"
    :show-close-button="false"
    :show-secondary-button="false"
    :width="600"
    title="Want to get the most out of Crossbeam?"
    description="Schedule a call with our Sales team today!"
    @action="closeDialog"
  >
    <div :id="ONBOARDING_CHILIPIPER_FORM_ID" class="book-meeting-form"></div>
  </BittsModal>
</template>

<script setup lang="ts">
import { BittsModal } from '@crossbeam/bitts';

import { useLocalStorage } from '@vueuse/core';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

import { useChilipiper } from '@/composables/useChilipiper';
import { useDataSourcesStore } from '@/stores';

const dataSourcesStore = useDataSourcesStore();

const { displayChilipiperWidget } = useChilipiper();

const isSubmitted = ref<boolean>(false);

const ONBOARDING_CHILIPIPER_FORM_ID = 'onboarding-chilipiper-form-id';

const bookedOrDismissedMeetingModal = useLocalStorage(
  'bookedOrDismissedMeetingModal',
  false,
);

onMounted(async () => {
  // Mark as shown immediately so we never re-prompt — even if ChiliPiper fails
  // to load and never fires onClose, or the user navigates away before closing.
  bookedOrDismissedMeetingModal.value = true;
  await dataSourcesStore.readySync;
  displayChilipiperWidget({
    chilipiperRouter: 'cb_onboarding_router',
    domElement: ONBOARDING_CHILIPIPER_FORM_ID,
    campaign: 'Onboarding Step',
    onSuccess: setSubmitted,
    onClose: closeDialog,
  });
});

const router = useRouter();
function closeDialog() {
  bookedOrDismissedMeetingModal.value = true;
  router.push({ name: 'onboarding' });
}
function setSubmitted() {
  isSubmitted.value = true;
}
</script>

<style lang="pcss" scoped>
@reference "../../css/theme.css";
.book-meeting-modal {
  :deep(.o-bitts-modal__footer) {
    @apply justify-end;
  }
  .book-meeting-form {
    @apply h-[425px] w-[520px] mx-auto relative overflow-hidden;

    & :deep(.chilipiper-popup) {
      @apply bg-transparent rounded-[10px] overflow-auto h-full;
    }
    & :deep(.chilipiper-popup-window) {
      @apply rounded-[10px] absolute h-[425px]! max-h-[425px]! w-[520px]! max-w-[520px]! top-0;
    }
  }
}
</style>
